import { useQuery } from '@tanstack/react-query';
import { StockTransaction, StockTransactionFilterInput } from '@models/warehouse.model';
import { warehouseService } from '@services/warehouse';

export const STOCK_TRANSACTIONS_QUERY_KEY = ['stockTransactions'];

export const useStockTransactions = (filter?: StockTransactionFilterInput) => {
  return useQuery<StockTransaction[], Error>({
    queryKey: [
      ...STOCK_TRANSACTIONS_QUERY_KEY,
      filter?.warehouseId,
      filter?.catalogId,
      filter?.categoryId,
      filter?.projectId,
      filter?.taskId,
      filter?.userId,
      filter?.type,
      filter?.startDate,
      filter?.endDate,
      filter?.limit,
    ],
    queryFn: async () => {
      const transactions = await warehouseService.getStockTransactions(filter);
      return transactions || [];
    },
    staleTime: 2 * 60 * 1000,
  });
};

export default useStockTransactions;
